// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  agentId: __t.u64().primaryKey().name("agent_id"),
  workspaceId: __t.u64().name("workspace_id"),
  remit: __t.string(),
  taskTagsJson: __t.string().name("task_tags_json"),
  modelLanesJson: __t.string().name("model_lanes_json"),
  skillsJson: __t.string().name("skills_json"),
  toolsJson: __t.string().name("tools_json"),
  memoryPrivilegesJson: __t.string().name("memory_privileges_json"),
  triggerContractJson: __t.string().name("trigger_contract_json"),
  reactionContractJson: __t.string().name("reaction_contract_json"),
  evidenceContractJson: __t.string().name("evidence_contract_json"),
  rubricJson: __t.string().name("rubric_json"),
  characterBudget: __t.string().name("character_budget"),
  safetyConstraintsJson: __t.string().name("safety_constraints_json"),
  version: __t.u32(),
  createdAt: __t.i64().name("created_at"),
  updatedAt: __t.i64().name("updated_at"),
});
